const initialState = {
    logErroGeral: [],
    idErro: 0,
    idFazenda: 0,
    fazenda: '',
    usuario: '',
    sistema: '',
    erro: '',
    dataCadastro: ''
};

export function logErroGeral(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_LOG_ERRO_GERAL':
            return {
                ...state,
                logErroGeral: action.logErroGeral
            };
        case 'LOG_ERRO_GERAL_DETAIL':
            return {
                ...state,
                idErro: action.idErro,
                idFazenda: action.idFazenda,
                fazenda: action.fazenda,
                usuario: action.usuario,
                sistema: action.sistema,
                erro: action.erro,
                dataCadastro: action.dataCadastro
            };
        case "LOG_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE_LOG_ERRO_GERAL":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
